import { render, staticRenderFns } from "./breadcrumb.vue?vue&type=template&id=b3057110"
import script from "./breadcrumb.vue?vue&type=script&lang=js"
export * from "./breadcrumb.vue?vue&type=script&lang=js"
import style0 from "./breadcrumb.vue?vue&type=style&index=0&id=b3057110&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_prettier@3.6.2_vue-template-compiler@2.7.16_webpack@5.102.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports